/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, withStyles, withTheme } from '@material-ui/core';
import { FilteringState, IntegratedFiltering } from '@devexpress/dx-react-grid';
import { Grid, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';
import { compose } from 'recompose';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { formatDateGeneric } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import Spinner from 'modules/common/spinner.component';

const styles = theme => {
  const border = `1px solid ${theme.palette.grey[500]}`;
  return {
    table: { borderSpacing: theme.spacing(0, 2) },
    tableHead: { height: 32 },
    cell: {
      borderTop: border,
      borderBottom: border,
      borderLeft: 0,
      borderRight: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderLeft: border
      },
      '&:last-child': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderRight: border
      }
    },
    row: { backgroundColor: theme.palette.common.white },
    noDataCell: { paddingBottom: theme.spacing(12), paddingTop: theme.spacing(12), textAlign: 'center' }
  };
};

class RecurringPayablesGrid extends PureComponent {
  static defaultProps = { isLoading: false };

  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: 'recurringPayableId', title: 'RP Num' },
        { name: 'recurringPayableStatus', title: 'Status' },
        { name: 'amount', title: 'Amount' },
        { name: 'payTo', title: 'Pay To' },
        { name: 'payee', title: 'Payee' },
        { name: 'startDate', title: 'Start Date' },
        { name: 'endDate', title: 'End Date' }
      ],
      filters: [],
      sorting: [{ columnName: 'startDate', direction: 'desc' }],
      tableColumnExtensions: []
    };
    this.changeSorting = sorting => this.setState({ sorting });
  }

  changeFilters = filters => this.setState({ filters });

  filterCell = props => (props.column.title ? <TableFilterRow.Cell {...props} /> : null);

  headerCell = props => (props.column.title ? <TableHeaderRow.Cell {...props} /> : null);

  headerRowComponent = props => <TableHeaderRow.Row className={this.props.classes.tableHead} {...props} />;

  rowComponent = props => <Table.Row className={this.props.classes.row} {...props} />;

  cellComponent = props => {
    const { column, row, value } = props;
    const id = row?.recurringPayableId;
    const className = classNames(this.props.classes.cell, 'handles-click');

    let display = value;
    switch (column.name) {
      case 'amount':
        display = row.amount == null ? '' : formatMoney(row.amount);
        break;
      case 'startDate':
        display = formatDateGeneric(row.startDate);
        break;
      case 'endDate':
        display = formatDateGeneric(row.endDate);
        break;
      case 'payTo':
        display = row.payTo || '';
        break;
      case 'payee':
        display = row.payee || '';
        break;
      case 'recurringPayableStatus':
        display = row.recurringPayableStatus || '';
        break;
      default:
        display = value;
    }

    return (
      <Table.Cell {...props} className={className} onClick={() => this.props.history.push(`/recurringPayables/${id}`)}>
        <Typography>{display}</Typography>
      </Table.Cell>
    );
  };

  tableComponent = props => <Table.Table className={this.props.classes.table} {...props} />;

  noDataCellComponent = props => {
    const content = this.props.isLoading ? <Spinner logo /> : 'No Records were returned.  Check the filters above.';
    const { getMessage, ...rest } = props;
    return (
      <Table.Cell {...rest} className={this.props.classes.noDataCell}>
        <Typography>{content}</Typography>
      </Table.Cell>
    );
  };

  render() {
    const { summaries = [] } = this.props;
    const { columns, filters, tableColumnExtensions, sorting } = this.state;

    return (
      <Grid rows={summaries} columns={columns}>
        <SortingState sorting={sorting} onSortingChange={this.changeSorting} />
        <FilteringState filters={filters} onFiltersChange={this.changeFilters} />
        <IntegratedFiltering />
        <IntegratedSorting />
        <Table
          columnExtensions={tableColumnExtensions}
          rowComponent={this.rowComponent}
          tableComponent={this.tableComponent}
          cellComponent={this.cellComponent}
          noDataCellComponent={this.noDataCellComponent}
        />
        <TableHeaderRow rowComponent={this.headerRowComponent} cellComponent={this.headerCell} showSortingControls />
        <TableFilterRow cellComponent={this.filterCell} />
      </Grid>
    );
  }
}

export default compose(withStyles(styles), withTheme)(RecurringPayablesGrid);
